export default function Coverage() {
  return (
    <section id="coverage" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="bg-slate-800 p-12 rounded-3xl">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Nationwide Coverage
            </h2>
            <p className="text-lg text-gray-300 mb-10 leading-relaxed">
              Operating across all 48 contiguous states with regional expertise in the Southwest and dedicated over-the-road services nationwide. Based in Dallas, TX - strategically positioned for optimal routing and efficient delivery.
            </p>

            <div className="grid grid-cols-2 gap-8 mb-10">
              <div>
                <div className="text-6xl font-bold text-white mb-2">48</div>
                <div className="text-lg text-gray-400">States Covered</div>
              </div>
              <div>
                <div className="text-6xl font-bold text-white mb-2">24/7</div>
                <div className="text-lg text-gray-400">Dispatch Available</div>
              </div>
            </div>

            <button className="bg-green-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-700 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
              View Service Areas
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-green-100 to-green-50 p-8 rounded-3xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7e83780b4bb535994996ee9f9dcf2eff.jpg"
                alt="Coverage Map"
                className="w-full h-auto rounded-2xl"
              />
              <div className="mt-6 grid grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 bg-green-600 rounded-full"></div>
                    <span className="text-sm font-semibold text-gray-700">Primary Hub: Dallas, TX</span>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl shadow-sm">
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 bg-slate-800 rounded-full"></div>
                    <span className="text-sm font-semibold text-gray-700">All 48 States</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-gray-50 rounded-2xl">
            <div className="text-4xl font-bold text-green-600 mb-2">500+</div>
            <div className="text-sm text-gray-600">Loads Delivered Monthly</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-2xl">
            <div className="text-4xl font-bold text-green-600 mb-2">99.8%</div>
            <div className="text-sm text-gray-600">On-Time Delivery Rate</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-2xl">
            <div className="text-4xl font-bold text-green-600 mb-2">15+</div>
            <div className="text-sm text-gray-600">Years Experience</div>
          </div>
          <div className="text-center p-6 bg-gray-50 rounded-2xl">
            <div className="text-4xl font-bold text-green-600 mb-2">100%</div>
            <div className="text-sm text-gray-600">Customer Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}